import React, { useState, useEffect } from "react";
import { useLoginCheck } from "../../hooks/useLoginCheck";

function JypSecretAudition26Page() {
  useLoginCheck();
  const [workshopData, setWorkshopData] = useState({});

  const fetchData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_jyp_secret_audition_26_orders/`);
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      setWorkshopData(data);
    } catch (error) {
      console.error("データの取得中にエラーが発生しました:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const workshopNames = {
    "4/11-Lv1": "4/11-レベル1",
    "4/11-Lv2": "4/11-レベル2",
  };

  const audNames = {
    "4/19-大阪": "4/19-大阪",
  };

  const getTotalAmount = () => {
    return workshopData.total_amount || 0;
  };

  const renderWorkshopSection = (workshopKey, workshopName) => {
    const workshop = workshopData[workshopKey];
    if (!workshop || !workshop.users || workshop.users.length === 0) {
      return (
        <div key={workshopKey} className="workshop-column">
          <div className="workshop-section">
            <h3 className="workshop-title">{workshopName} (参加者: 0名)</h3>
          </div>
        </div>
      );
    }

    return (
      <div key={workshopKey} className="workshop-column">
        <div className="workshop-section">
          <h3 className="workshop-title">
            {workshopName} (参加者: {workshop.users.length}名)
          </h3>

          <ul className="customer-grid customer-header">
            <li className="cell">No</li>
            <li className="cell">名前</li>
            <li className="cell">メール</li>
            <li className="cell">電話番号</li>
          </ul>

          {workshop.users.map((user, i) => (
            <ul key={user.id} className="customer-grid">
              <li className="cell">{i + 1}</li>
              <li className="cell">{user.name}</li>
              <li className="cell">{user.email}</li>
              <li className="cell">{user.phone}</li>
            </ul>
          ))}
        </div>
      </div>
    );
  };

  const renderAuditionSection = (audKey, audName) => {
    const aud = workshopData[audKey];
    if (!aud || !aud.users || aud.users.length === 0) {
      return (
        <div key={audKey} className="workshop-column audition-column">
          <div className="workshop-section">
            <h3 className="workshop-title">{audName} (参加者: 0名)</h3>
          </div>
        </div>
      );
    }

    return (
      <div key={audKey} className="workshop-column audition-column">
        <div className="workshop-section">
          <h3 className="workshop-title">
            {audName} (参加者: {aud.users.length}名)
          </h3>

          <ul className="audition-grid audition-header">
            <li className="cell">順番</li>
            <li className="cell">名前</li>
            <li className="cell">生年</li>
            <li className="cell">性別</li>
            <li className="cell">国籍／海外居住期間</li>
            <li className="cell">外国語能力レベル</li>
            <li className="cell">分野</li>
            <li className="cell">身長</li>
            <li className="cell">体重</li>
            <li className="cell">学校</li>
            <li className="cell">連絡先</li>
          </ul>

          {aud.users.map((user, i) => (
            <ul key={user.id} className="audition-grid">
              <li className="cell">{i + 1}</li>
              <li className="cell">{user.name}</li>
              <li className="cell">{user.birthdate}</li>
              <li className="cell">{user.gender}</li>
              <li className="cell">{user.nationality}</li>
              <li className="cell">{user.foreign_language}</li>
              <li className="cell">{user.field}</li>
              <li className="cell">{user.height}</li>
              <li className="cell">{user.weight}</li>
              <li className="cell">{user.school}</li>
              <li className="cell">
                <div>{user.phone}</div>
                <div>{user.email}</div>
              </li>
            </ul>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="ws-patt-page">
      <div className="page-container">
        <div className="total-amount-section">
          <h3 className="total-amount-title">
            合計金額: ¥{getTotalAmount().toLocaleString()}
          </h3>
          <h3 className="section-title">
            ワークショップ
          </h3>
        </div>

        <div className="workshop-grid">
          {Object.keys(workshopNames).map((workshopKey) =>
            renderWorkshopSection(workshopKey, workshopNames[workshopKey])
          )}
        </div>

        <div className="total-amount-section">
          <h3 className="section-title">
            オーディション
          </h3>
        </div>

        <div className="audition-full-width">
          {Object.keys(audNames).map((audKey) =>
            renderAuditionSection(audKey, audNames[audKey])
          )}
        </div>
      </div>
    </div>
  );
}

export default JypSecretAudition26Page;
